(function(){
  /* to add google analytics event, fire: $(document).trigger('checkoutStep','any_description_here'); */
  window.dataLayer = window.dataLayer || [];
  $(document).on('checkoutStep',function(evt, checkoutStep){
    var regexp = /^[a-zA-Z0-9-_]+$/;
    if(typeof checkoutStep === 'string' && checkoutStep.length > 0 && checkoutStep.search(regexp > -1)){
      window.dataLayer.push({
        'event': 'checkout',
        'checkout-step': checkoutStep
      });
    }
  });
  /* example trigger: $(document).trigger('checkoutFormSubmit',['#save_cc']); */
  $(document).on('checkoutFormSubmit',function(evt, selector){
    switch(selector) {
      case '#save_cc':
        let elementValue = $(selector).is(':checked');
        window.dataLayer.push({
          'event': 'checkout-submit-payment',
          'save-credit-card' : elementValue
        });
        break;
      //to track additional form-elements, add case for selector here

    }
  });

  $(document).on('finalizedOrder',function(evt,ecomData){
    window.dataLayer.push({ 'ecommerce': ecomData });    
  });

  $(document).on('paypal-express-click',function(evt,orderId){
    window.dataLayer.push({
      'event': 'paypal-express-click',
      'ck-order-id' : orderId
    });
  });

  $(document).on('paypal-express-finalize',function(evt,orderId){
    window.dataLayer.push({
      'event': 'paypal-express-finalize',
      'ck-order-id' : orderId
    });
  });

  $(document).on('save-for-later-move-to-cart', function(evt, productId, productPrice) {
    dataLayer.push({
      'event': 'addToCart',
      'ecommerce': {
        'currencyCode': 'USD',
        'add': {
          'products': [{
            'id': productId,
            'price': productPrice
           }]
        }
      }
    })
  });

})();